import {
  Component,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { ICourseCategoryType } from 'src/app/interfaces/interfaces/study-material';
import { IStudyMaterial } from 'src/app/interfaces/StudyUnit';
import {
  IApplicableCourseCategory,
  IApplicableCoursePlan,
  ICoursePlan,
} from 'src/app/Models/StudyUnit';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { VStudyMaterial } from 'src/app/Validators/Validators';

@Component({
  selector: 'app-assign-studymaterial-modal',
  templateUrl: './assign-studymaterial-modal.component.html',
  styleUrls: ['./assign-studymaterial-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AssignStudymaterialModalComponent implements OnInit {
  @Input() StudyUnit: any; // Input property to receive data
  @Output() editAssignMaterial = new EventEmitter<any>();
  @Output() previewEvent = new EventEmitter<any>(); // EventEmitter to notify parent

  AddStudyMaterialform: FormGroup;
  getmaterial: IGetCodes[];
  getmateriallevel: IGetCodes[];
  getstatus: IGetCodes[];
  versionOptions: number[] = Array.from({ length: 100 }, (_, i) => i + 1);
  courseDifficultyType: IGetCodes[] = [];
  Descriptionvaluelength: { [key: number]: number } = {};
  DescriptionMaxlength = 4000;
  StudyMaterials: IStudyMaterial[];
  courseCategoryList: IGetCodes[];
  COURSE_PLAN_TYPE: IGetCodes[];
  applicableCourses: any[];
  path: string;
  constructor(
    private modalService: ModalService,
    private readonly toaster: ToastrService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    public service: ContentManagementService,
    public Activeroute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const screenName = this.Activeroute.snapshot.paramMap.get('ScreenName');
    const studyUnitID = this.StudyUnit?.ID || 0;
    this.fetchCoursePlanTypes();
    forkJoin({
      courseCategoryList: this.service.getDropdownListByCode(
        'COURSE_CATEGORY_TYPE'
      ),
      studyMaterialList: this.getStudyMaterialList(screenName, studyUnitID),
      applicableCoursePlan: this.service
        .GetStudyMaterialApplicableCoursePlan(
          UserAuthDetails.getUserLoggedInId(),
          null,
          null,
          null,
          'Y',
          'ASSIGN_STUDY_MATERIAL_TO_COURSE_PLAN',
          this.StudyUnit?.ID
        )
        .pipe(map((e: any) => e?.GetStudyMaterialApplicableCoursePlan ?? [])),
      // applicableCoursePlanCategories:of(ConstantVars.Test)
      applicableCoursePlanCategories: this.service
        .getStudyMaterialApplicableCourseCategory(
          UserAuthDetails.getUserLoggedInId(),
          null,
          'Y',
          'ASSIGN_STUDY_MATERIAL_TO_COURSE_PLAN',
          this.StudyUnit?.ID
        )
        .pipe(map((e: any) => e.GetStudyMaterialApplicableCourseCategory)),
      path: this.service
        .getBreadcrumb({
          ID: studyUnitID,
          Screenname: 'CONTENT_MANAGEMENT',
        })
        .pipe(map((e: any) => e.Data)),
    }).subscribe(
      ({
        courseCategoryList,
        studyMaterialList,
        applicableCoursePlan,
        applicableCoursePlanCategories,
        path,
      }) => {

        this.path = path;
        // Set course category list
        this.courseCategoryList = courseCategoryList as IGetCodes[];
        this.applicableCourses = applicableCoursePlan;
        // Populate the Study Materials
        this.populateStudyMaterials(
          studyMaterialList.StudyMaterial as IStudyMaterial[]
        );
        const studyMaterialsFormArray = this.getStudyMaterialsArray();
        this.StudyMaterials = studyMaterialList?.StudyMaterial;

        studyMaterialList.StudyMaterial.forEach(
          (element: any, studyMaterialIndex: number) => {
            // const constcourseCategoryType = this.getCourseCategoryControls(studyMaterialIndex)
            this.courseCategoryList.forEach((cc: any) => {
              this.addCourseCategoryType(
                studyMaterialIndex,
                cc,
                applicableCoursePlanCategories
              );
            });
            // Populate Applicable Exam List
            this.populateApplicableExamList(
              studyMaterialIndex,
              applicableCoursePlan
            );
          }
        );
      }
    );
    // this.StudyMaterialList(this.StudyUnit?.ID);
    this.getMaterial();
    this.getStatus();
    this.getMaterialLevel();
    this.InitializeForm();
    this.getLists();
  }

  EditStudyMaterial(studyMaterialIndex: number) {
    const studymaterial = this.StudyMaterials[studyMaterialIndex];
    this.editAssignMaterial.emit(studymaterial);
  }
  // getBreadcrumbDetails() {
  //   // this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
  //   //   this.Breadcrumblist = i;

  //   this.service
  //     .getBreadcrumb({
  //       ID: this.SubjectlistID,
  //       Screenname: 'CONTENT_MANAGEMENT',
  //     })
  //     .subscribe(
  //       (i: any) => {
  //         this.Breadcrumblist = i;
  //         this.Breadcrumb = this.Breadcrumblist.Data;
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // }

  StudyMaterialList(data: any) {
    let ID: Number = 0;
    if (data != null) {
      ID = Number(data);
    }

    let list: any = {};
    if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'STUDY UNIT') {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'ALL';
    } else if (this.Activeroute.snapshot.paramMap.get('ScreenName') == 'WIP') {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'WIP';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Approved'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Approved';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Defer'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Defer';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rejected'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Rejected';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Rework'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Rework';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Under Review'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Under Review';
    } else if (
      this.Activeroute.snapshot.paramMap.get('ScreenName') == 'Submitted'
    ) {
      //let list: any = {};
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'Submitted';
    } else {
      list['StudyUnitID'] = ID;
      list['StudyMaterialStatusTypeCode'] = 'ALL';
    }

    this.service.GetStudyMaterialList(list).subscribe(
      (res: any) => {
        this.StudyMaterials = res.StudyMaterial as IStudyMaterial[];
        this.populateStudyMaterials(this.StudyMaterials);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  InitializeForm() {
    this.AddStudyMaterialform = this.fb.group({
      StudyMaterials: this.fb.array([]),
    });
    // Optionally, add the first study material
    // this.addStudyMaterial();
  }

  populateStudyMaterials(materials: IStudyMaterial[]) {
    const studyMaterialsFormArray = this.getStudyMaterialsArray();

    materials.forEach((material) => {
      const studyMaterialForm = this.fb.group({
        Study_Material_Type_Code: [
          { value: material.Study_Material_Type_Code || '', disabled: true },
          VStudyMaterial,
        ],
        Study_Material_Level_Type: [
          {
            value: material.Study_Material_Level_Type_Code || '',
            disabled: true,
          },
          VStudyMaterial,
        ],
        Study_Material_Name: [
          { value: material.Study_Material_Name || '', disabled: true },
          VStudyMaterial,
        ],
        Study_Material_Status_Type_Code: [
          {
            value: material.Study_Material_Status_Type_Code || '',
            disabled: true,
          },
        ],
        Version_Number: [
          { value: material.Version_Number || '', disabled: true },
        ],
        Free_Resource_Ind: [
          { value: material.Free_Study_Material_Ind === 'Y', disabled: true },
        ],
        ReferenceStudyMaterialInd: [
          {
            value: material.Reference_Study_Material_Ind === 'Y',
            disabled: true,
          },
        ],
        PrimaryStudyMaterialInd: [
          {
            value: material.Primary_Study_Material_Ind === 'Y',
            disabled: true,
          },
        ],
        Duration_In_Minutes: [
          { value: material.Duration_In_Minutes || '', disabled: true },
        ],
        NumberOfPages: [
          { value: material.Number_Of_Pages || '', disabled: true },
        ],
        Display_Name: [{ value: material.Display_Name || '', disabled: true }],
        File_Name: [{ value: material.File_Name || '', disabled: true }],
        FileUpload: [null], // Set file upload to null initially
        StudyMaterialId: [
          { value: material.Study_Material_Id || '', disabled: false },
        ],
        Study_Material_Difficulty_Level_Type: [
          {
            value: material.Study_Material_Difficulty_Level_Type_Code || '',
            disabled: true,
          },
        ],
        File_Location_Name: [
          { value: `${material.File_Location_Name}${material.File_Name_In_Server}` || '', disabled: true },
        ],
        File_Object_Id: [
          { value: material.File_Object_Id || '', disabled: true },
        ],
        Study_Material_Url:[{ value: material.Study_Material_Url || '', disabled: true }],
        File_Name_In_Server: [
          { value: material.File_Name_In_Server || '', disabled: true },
        ],
        File_Del_Ind: [{ value: material.Deleted_Ind || 'N', disabled: true }],
        File_Source_Modified_Datetime: [
          {
            value: material.File_Source_Modified_Datetime || '',
            disabled: true,
          },
        ],
        File_Type_Code: [
          { value: material.File_Type_Code || '', disabled: true },
        ],
        File_Type_Name: [
          { value: material.File_Type_Name || '', disabled: true },
        ],
        Description_Text: [
          { value: material.Description_Text || '', disabled: true },
        ],
        Course_Category_Type: this.fb.array([]), // Initialize empty arrays
        Applicable_Exam_List: this.fb.array([]),
      });

      studyMaterialsFormArray.push(studyMaterialForm);
    });
    this.Descriptioncount();
  }

  populateApplicableExamList(
    studyMaterialIndex: number,
    applicableCoursePlans: IApplicableCoursePlan[]
  ) {
    const studyMaterialsArray = this.getStudyMaterialsArray();
    const studyMaterialForm = studyMaterialsArray.at(
      studyMaterialIndex
    ) as FormGroup;
    const applicableExamListArray = studyMaterialForm.get(
      'Applicable_Exam_List'
    ) as FormArray;
    const studyMaterialId = studyMaterialForm.value.StudyMaterialId;

    const filteredPlans = applicableCoursePlans.filter(
      (plan) => plan.Study_Material_Id === studyMaterialId
    );
    // Create a unique array by Course_ID
    const uniquePlansByCourseID = Array.from(
      new Map(filteredPlans.map((plan) => [plan.Course_ID, plan])).values()
    );
    const planRequests = uniquePlansByCourseID.map((plan, index, self) => {
      forkJoin({
        examAgencies: this.service.GetCode({
          Tablename: `EXAM_AGENCY@${plan.Course_Category_Type_Code}`,
        }),
        courseList: this.service.GetCode({
          Tablename: `EXAM_COURSE@${plan.Exam_Agency_ID}@${plan.Course_Category_Type_Code}`,
        }),
        courseYear: this.service.GetCode({
          Tablename: `COURSE_YEAR@${plan.Course_Master_Id}@${plan.Course_Category_Type_Code}`,
        }),
        coursePlan: this.service
          .getCoursePlan$(
            UserAuthDetails.getUserLoggedInId(),
            plan.Course_ID,
            '',
            'ASSIGNSTUDYMATERIAL',
            '',
            ''
          )
          .pipe(map((e: any) => e.coursePlan)),
      }).subscribe(({ examAgencies, courseYear, coursePlan, courseList }) => {
        applicableExamListArray.push(
          this.fb.group({
            examAgency: [plan.Exam_Agency_ID, Validators.required],
            courseId: [plan.Course_Master_Id, Validators.required],
            examYear: [plan.Course_ID, Validators.required],
            deleteInd: [plan?.Deleted_Ind || 'N'],
            type: [plan.Course_Category_Type_Code],
            examAgencyList: [examAgencies],
            courseList: [courseList],
            courseYear: [courseYear],
            coursePlan: [coursePlan],
            selectedCoursePlans: this.fb.array(
              coursePlan.map((planItem: any) =>
                this.fb.group({
                  CoursePlanTypeCode: [planItem.Course_Plan_Type_Code],
                  CourseID: [planItem.Course_Id],
                  SelectedInd: [
                    filteredPlans.some(
                      (selectedPlan) =>
                        selectedPlan.Course_Plan_ID ===
                          planItem.Course_Plan_Id &&
                        selectedPlan.Deleted_Ind === 'N'
                    ),
                  ],
                })
              )
            ),
          })
        );
      });
    });
  }

  getStudyMaterialList(
    screenName: string | null,
    studyUnitID: number
  ): Observable<any> {
    const list: any = {
      StudyUnitID: studyUnitID,
      StudyMaterialStatusTypeCode: 'ALL', // Default to 'ALL'
    };

    if (screenName) {
      switch (screenName) {
        case 'WIP':
          list.StudyMaterialStatusTypeCode = 'WIP';
          break;
        case 'Approved':
          list.StudyMaterialStatusTypeCode = 'Approved';
          break;
        case 'Defer':
          list.StudyMaterialStatusTypeCode = 'Defer';
          break;
        case 'Rejected':
          list.StudyMaterialStatusTypeCode = 'Rejected';
          break;
        case 'Rework':
          list.StudyMaterialStatusTypeCode = 'Rework';
          break;
        case 'Under Review':
          list.StudyMaterialStatusTypeCode = 'Under Review';
          break;
        case 'Submitted':
          list.StudyMaterialStatusTypeCode = 'Submitted';
          break;
        default:
          list.StudyMaterialStatusTypeCode = 'ALL';
      }
    }

    return this.service.GetStudyMaterialList(list);
  }

  createStudyMaterial(): FormGroup {
    return this.fb.group({
      Study_Material_Type_Code: ['', VStudyMaterial],
      Study_Material_Level_Type: ['', VStudyMaterial],
      Study_Material_Name: ['', VStudyMaterial],
      Study_Material_Status_Type_Code: [''],
      Version_Number: [],
      Free_Resource_Ind: [false],
      ReferenceStudyMaterialInd: [false],
      PrimaryStudyMaterialInd: [false],
      Duration_In_Minutes: [],
      NumberOfPages: [],
      Display_Name: [''],
      File_Name: [''],
      FileUpload: [],
      StudyMaterialId: [],
      Study_Material_Difficulty_Level_Type: [],
      File_Location_Name: [''],
      Study_Material_Url: [''],
      File_Object_Id: [],
      File_Name_In_Server: [],
      File_Del_Ind: ['N'],
      File_Source_Modified_Datetime: [],
      File_Type_Code: [],
      File_Type_Name: [],
      Description_Text: [''],
      Course_Category_Type: this.fb.array([]),
      Applicable_Exam_List: this.fb.array([]),
    });
  }
  onPreview(studyMaterial: any, StudyMaterialIndex: number) {
    let list = {
      Formvalue: studyMaterial.value,
      StudyMateriallist: this.StudyMaterials[StudyMaterialIndex],
    };
    this.previewEvent.emit(list);
  }
  getStudyMaterialsArray(): FormArray {
    return this.AddStudyMaterialform.get('StudyMaterials') as FormArray;
  }

  addStudyMaterial() {
    this.getStudyMaterialsArray().push(this.createStudyMaterial());
  }

  removeStudyMaterial(index: number) {
    this.getStudyMaterialsArray().removeAt(index);
  }

    shortenString(str:string, limit = 12) {
  if (typeof str !== 'string') return '';
  return str.length > limit ? str.slice(0, limit) + '...' : str;
  }

  getMaterial() {
    this.service.GetCode({ Tablename: 'Study_Material_Type' }).subscribe({
      next: (i: any) => {
        this.getmaterial = i;
      },
      error: (error) => {
        console.error('Error fetching Study Material Types:', error);
        this.toaster.error('Failed to fetch Study Material Types.');
      },
    });
  }

  getMaterialLevel() {
    this.service.GetCode({ Tablename: 'Study_Material_Level_Type' }).subscribe({
      next: (i: any) => {
        this.getmateriallevel = i;
      },
      error: (error) => {
        console.error('Error fetching Material Levels:', error);
        this.toaster.error('Failed to fetch Material Levels.');
      },
    });
  }

  getStatus() {
    this.service
      .GetCode({ Tablename: 'Study_Material_Status_Type' })
      .subscribe({
        next: (i: any) => {
          this.getstatus = i;
        },
        error: (error) => {
          console.error('Error fetching Status:', error);
          this.toaster.error('Failed to fetch Status.');
        },
      });
  }

  Descriptioncount() {
    const materials = this.getStudyMaterialsArray();
    materials.controls.forEach((control, index) => {
      const description = control.get('Description_Text')?.value || '';
      this.Descriptionvaluelength[index] = description.length;
    });
  }

  getLists() {
    forkJoin([
      this.service.getDropdownListByCode('COURSE_CATEGORY_TYPE'),
      this.service.getDropdownListByCode('YEAR'),
      this.service.getExamAgencyList(UserAuthDetails.getUserLoggedInId()),
      this.service.getDropdownListByCode(
        'STUDY_MATERIAL_DIFFICULTY_LEVEL_TYPE'
      ),
      // this.service.GetCode({ Tablename: 'EXAM_AGENCY' }),
    ]).subscribe((listData) => {
      const [courseCategoryType, examYear, agencyList, courseDifficultyType] =
        listData;

      // this.examAgencyList = agencyList;
      // this.courseList = [];
      // this.courseYearList = examYear;
      // this.courseCategoryList = courseCategoryType;
      this.courseDifficultyType = courseDifficultyType as IGetCodes[];

      // (
      //   this.AddStudyMaterialform.get('Course_Category_Type') as FormArray
      // ).clear();

      // (courseCategoryType as any).forEach((elem: any) => {
      //   this.addCourseCategoryType(elem.Description, elem.Code, false);
      //   // this.addApplicableExamList({ type: elem.Code });
      // });
    });
  }
  // Getters for the FormArrays
  getCourseCategoryControls(index: number): FormArray {
    return this.getStudyMaterialsArray()
      .at(index)
      .get('Course_Category_Type') as FormArray;
  }
  async onCourseCategoryTypeChange(
    event: any,
    ccType: any,
    studymaterialIndex: number
  ) {
    const formGroup: ICourseCategoryType = ccType.value;
    const cCategoryType = formGroup.CourseCategoryTypeCode;
    const formArray = this.getStudyMaterialsArray()
      .at(studymaterialIndex)
      .get('Applicable_Exam_List') as FormArray;
    if (!event.target.checked) {
      try {
        const result = await this.modalService.open(
          'Confirmation',
          `Do you want to remove the Applicable Course Type "${formGroup.CourseCategoryTypeName}"?`
        );
        if (result) {
          // Iterate through the FormArray and remove matching FormGroups
          console.log(formArray);
          for (let i = formArray.length - 1; i >= 0; i--) {
            const group = formArray.at(i).value;
            if (group.type === cCategoryType) {
              // formArray.removeAt(i);  Remove FormGroup at index
              const selectedCoursePlanTypeArray = formArray
                .at(i)
                .get('selectedCoursePlans');
              const formGroup = formArray.at(i);
              ['courseId', 'examAgency', 'examYear'].forEach((field) => {
                formGroup.get(field)?.removeValidators(Validators.required);
                formGroup.get(field)?.updateValueAndValidity();
              });
              const DeleteInd = formArray.at(i).get('deleteInd');
              if (DeleteInd) {
                DeleteInd.setValue('Y');
              }
              if (selectedCoursePlanTypeArray) {
                const selectedPlans = selectedCoursePlanTypeArray.value; // Retrieve the array of selected plans
                // Set all SelectedInd to false
                selectedPlans.forEach((plan: any) => {
                  plan.SelectedInd = false;
                });

                // Update the form control with the modified values
                selectedCoursePlanTypeArray.setValue(selectedPlans);
              }
            }
          }
        } else {
          // User canceled, programmatically re-check the checkbox
          ccType.get('SelectedInd')?.setValue(true);
        }
      } catch (error) {
        console.log('Modal dismissed:', error);
        // Modal dismissed, re-check the checkbox
        ccType.get('SelectedInd')?.setValue(true);
      }
    } else {
      this.service
        .GetCode({
          Tablename: `EXAM_AGENCY@${cCategoryType}`,
        })
        .subscribe((elem: any) => {
          formArray?.push(
            this.fb.group({
              examAgency: [null, Validators.required],
              courseId: [null, Validators.required],
              examYear: [null, Validators.required],
              deleteInd: ['N'],
              courseList: [],
              courseYear: [],
              coursePlan: [],
              selectedCoursePlans: this.fb.array([]),
              type: [cCategoryType],
              examAgencyList: [elem],
            })
          );
        });
    }
  }

  getApplicableExamControls(index: number): FormArray {
    return this.getStudyMaterialsArray()
      .at(index)
      .get('Applicable_Exam_List') as FormArray;
  }

  // Adding to Course_Category_Type
  addCourseCategoryType(
    studyMaterialIndex: number,
    category: IGetCodes,
    applicableCoursePlanCategories: IApplicableCourseCategory[]
  ) {
    const studyMaterialsArray = this.getStudyMaterialsArray();
    const studyMaterialForm = studyMaterialsArray.at(
      studyMaterialIndex
    ) as FormGroup;
    const courseCategoryArray = studyMaterialForm.get(
      'Course_Category_Type'
    ) as FormArray;
    // Extract StudyMaterialId for the current study material
    const studyMaterialId = studyMaterialForm.value.StudyMaterialId;
    // Check if the course category is selected for the current study material
    const isSelected = applicableCoursePlanCategories.some(
      (cc) =>
        cc.Study_Material_Id === studyMaterialId &&
        cc.Course_Category_Type_Code === category.Code &&
        cc.Selected_Ind === 'Y'
    );

    // Add the course category to the form array
    courseCategoryArray.push(
      this.fb.group({
        CourseCategoryTypeCode: [category.Code],
        SelectedInd: [isSelected],
        CourseCategoryTypeName: [category.Description],
      })
    );
  }

  getApplicableExamListForStudyMaterial(
    studyMaterialIndex: number
  ): FormArray | null {
    const studymaterialArray = this.AddStudyMaterialform.get(
      'StudyMaterials'
    ) as FormArray;
    if (!studymaterialArray) {
      return null;
    }

    const applicableExamList = studymaterialArray
      .at(studyMaterialIndex)
      .get('Applicable_Exam_List') as FormArray;

    return applicableExamList;
  }
  // Adding to Applicable_Exam_List

  addApplicableExamList(item: any, smIndex: number): void {
    const studyMaterialsArray = this.getStudyMaterialsArray();
    const studyMaterialGroup = studyMaterialsArray.at(smIndex) as FormGroup;
    const applicableExamList = studyMaterialGroup.get(
      'Applicable_Exam_List'
    ) as FormArray;
    if (this.validateSelectedCoursePlans(applicableExamList.value, item.type)) {
      return; // Stop execution if validation fails
    }
    const newExamGroup = this.fb.group({
      examAgency: [null, Validators.required],
      courseId: [null, Validators.required],
      examYear: [null, Validators.required],
      type: [item.type],
      examAgencyList: [[]],
      deleteInd: 'N',
      courseList: [[]],
      coursePlan: [[]],
      courseYear: [[]],
      selectedCoursePlans: this.fb.array([]),
    });

    applicableExamList.push(newExamGroup);
    this.fetchExamAgency(newExamGroup, item.type);
  }

  validateSelectedCoursePlans(examData: any[], newType: string): boolean {
    let hasValidCoursePlan = false; // Track if at least one valid object exists

    // Filter out objects where deleteInd is 'N' and match the same type
    let validData = examData.filter(
      (item) => item.deleteInd === 'N' && item.type === newType
    );
    hasValidCoursePlan = validData.every((item) => {
      return item.selectedCoursePlans && item.selectedCoursePlans.length > 0;
    });

    // Show error if no valid selectedCoursePlans exist for this type
    if (!hasValidCoursePlan) {
      this.toaster.error(
        `You cannot add a new row for type "${newType}" because all existing ones have empty selected course plans.`,
        'Error',
        { timeOut: ConstantVars.ToastErrorTimeout }
      );
      return true; // Prevent adding new object
    }

    return false; // Allow adding new object
  }

  isActivated(code: string, index: number): boolean {
    // Safely access the StudyMaterials FormArray
    const studyMaterialArray = this.AddStudyMaterialform.get(
      'StudyMaterials'
    ) as FormArray;

    // Ensure the StudyMaterials array and the specific study material at the index exist
    if (!studyMaterialArray || !studyMaterialArray.at(index)) {
      return false; // Return false if the study material doesn't exist
    }

    // Access the specific study material FormGroup
    const studyMaterial = studyMaterialArray.at(index) as FormGroup;

    // Safely get the Course_Category_Type array
    const courseCategoryArray = studyMaterial.get(
      'Course_Category_Type'
    )?.value;

    if (!Array.isArray(courseCategoryArray)) {
      return false; // Return false if Course_Category_Type is not a valid array
    }

    // Find the course category with the provided code
    const courseCategory = courseCategoryArray.find(
      (accu: any) => accu.CourseCategoryTypeCode === code
    );

    // Return whether the category is activated (SelectedInd is true)
    return courseCategory?.SelectedInd ?? false;
  }

  CheckIfCourseType(index: number, type: string): boolean {
    // Access the StudyMaterials FormArray
    const studyMaterialArray = this.AddStudyMaterialform.get(
      'StudyMaterials'
    ) as FormArray;

    // Ensure the StudyMaterials array and the specific study material at the index exist
    if (!studyMaterialArray || !studyMaterialArray.at(index)) {
      return false; // Return false if the study material doesn't exist
    }

    // Access the Applicable_Exam_List FormArray for the specific study material
    const applicableExamList = studyMaterialArray
      .at(index)
      .get('Applicable_Exam_List') as FormArray;

    if (!applicableExamList) {
      return false; // Return false if Applicable_Exam_List is not defined
    }

    // Check if any entry in the Applicable_Exam_List matches the specified type
    return applicableExamList.value.some((exam: any) => exam.type === type);
  }
  CheckIfAnySelectedCoursePlan(appExam: any, index: number): boolean {
    const selectedCourses = appExam?.selectedCoursePlans ?? null;

    // Return true if `selectedCoursePlans` is undefined, null, or an empty array
    if (!selectedCourses || selectedCourses.length === 0) {
      return true;
    }

    // Return true if any item in the array has `SelectedInd` set to `true`
    return (
      appExam.deleteInd === 'N' ||
      selectedCourses.some((e: any) => e.SelectedInd === true)
    );
  }

  fetchCoursePlanTypes() {
    this.service
      .GetCode({
        Tablename: `COURSE_PLAN_TYPE`,
      })
      .subscribe((elem) => {
        this.COURSE_PLAN_TYPE = elem;
        // appExam.get('courseYear').setValue(elem || []);
      });
  }
  // Fetch exam agency list based on course category type
  fetchExamAgency(appExam: FormGroup, type: string) {
    this.service
      .GetCode({ Tablename: `EXAM_AGENCY@${type}` })
      .subscribe((response: any[]) => {
        appExam.get('examAgencyList')?.setValue(response);
        appExam.get('courseId')?.setValue('');
        appExam.get('examYear')?.setValue('');
      });
  }

  // Fetch course list based on selected exam agency
  fetchCourseList(appExam: any, type: string) {
    const agencyCode = appExam.get('examAgency')?.value;

    this.service
      .GetCode({ Tablename: `EXAM_COURSE@${agencyCode}@${type}` })
      .subscribe((response: any[]) => {
        appExam.get('courseList')?.setValue(response);
        appExam.get('courseId')?.reset();
        appExam.get('coursePlan')?.reset();
        appExam.get('examYear')?.reset();
        const planArray = appExam.get('selectedCoursePlans');
        const selectedPlans = planArray.value; // Retrieve the array of selected plans
        // Set all SelectedInd to false
        selectedPlans.forEach((plan: any) => {
          plan.SelectedInd = false;
        });

        // Update the form control with the modified values
        planArray.setValue(selectedPlans);
        console.log(planArray);
        console.log(appExam);
      });
  }

  // Fetch course year list based on selected course
  fetchCourseYears(appExam: any, type: string) {
    const courseId = appExam.get('courseId')?.value;

    this.service
      .GetCode({ Tablename: `COURSE_YEAR@${courseId}@${type}` })
      .subscribe((response: any[]) => {
        appExam.get('courseYear')?.setValue(response);
        appExam.get('examYear')?.reset();
        appExam.get('selectedCoursePlans')?.reset();
        appExam.get('coursePlan')?.reset();
        appExam.updateValueAndValidity();
      });
  }
  // Fetch Course Plans for a course in a specific study material
  getCoursePlan(
    studyMaterialIndex: number,
    applicableExamIndex: number,
    selectedCoursePlans?: any[]
  ) {
    // Access the specific study material FormArray
    const studyMaterialsArray = this.AddStudyMaterialform.get(
      'StudyMaterials'
    ) as FormArray;

    // Ensure the study material exists at the specified index
    if (!studyMaterialsArray?.at(studyMaterialIndex)) {
      console.error('Study material not found at the specified index.');
      return;
    }
    console.log(this.applicableCourses, 'Applicable Courses ............');

    // Access the Applicable_Exam_List for the given study material
    const applicableExamList = studyMaterialsArray
      .at(studyMaterialIndex)
      .get('Applicable_Exam_List') as FormArray;
    const tempapplicableExams = applicableExamList.value;
    if (this.checkDuplicateExamYear(tempapplicableExams)) {
      const appExamGroup = applicableExamList.at(
        applicableExamIndex
      ) as FormGroup;

      // Retrieve the examYear from the FormGroup
      appExamGroup.get('examYear')?.setValue('');
      appExamGroup.get('coursePlan')?.reset([]);
      appExamGroup.get('selectedCoursePlans')?.reset();
      const courseList = appExamGroup.get('courseList')?.value;
      const courseId = appExamGroup.get('courseId')?.value;
      const courseName =
        courseList.find((e: any) => +e.Code === +courseId)?.Description ?? '';
      //  Retrieve the examYear from the appExamGroup
      appExamGroup.get('examYear')?.reset();
      appExamGroup.get('coursePlan')?.setValue([]);
      appExamGroup.get('selectedCoursePlan')?.setValue([]);
      this.toaster.error(
        `Course year is already selected for "${courseName}" `,
        'Error',
        {
          timeOut: ConstantVars.ToastErrorTimeout,
        }
      );
    }
    // Ensure the applicable exam exists at the specified index
    if (!applicableExamList?.at(applicableExamIndex)) {
      console.error('Applicable exam not found at the specified index.');
      return;
    }

    // Access the specific exam FormGroup
    const appExamGroup = applicableExamList.at(
      applicableExamIndex
    ) as FormGroup;

    // Retrieve the examYear from the FormGroup
    const courseId = appExamGroup.get('examYear')?.value;

    // Fetch course plans from the service
    this.service
      .getCoursePlan$(
        UserAuthDetails.getUserLoggedInId(),
        courseId,
        '',
        'ASSIGNSTUDYMATERIAL',
        '',
        ''
      )
      .subscribe(
        (res: any) => {
          if (appExamGroup) {
            // Update the coursePlan FormArray
            appExamGroup.get('coursePlan')?.patchValue(res?.coursePlan);

            // Access or initialize the selectedCoursePlan FormArray
            const selectedCoursePlanArray = appExamGroup.get(
              'selectedCoursePlans'
            ) as FormArray;
            if (selectedCoursePlanArray) {
              selectedCoursePlanArray.clear();
            } // Clear existing controls

            // Populate the selectedCoursePlan FormArray
            res?.coursePlan.forEach((plan: any) => {
              const isSelected =
                selectedCoursePlans?.some(
                  (selectedPlan) =>
                    selectedPlan.Course_Plan_ID === plan.Course_Plan_Id &&
                    selectedPlan.Deleted_Ind === 'N'
                ) || false;
              if (selectedCoursePlanArray) {
                selectedCoursePlanArray.push(
                  this.fb.group({
                    CoursePlanTypeCode: [plan.Course_Plan_Type_Code],
                    CourseID: [plan.Course_Id], // Assuming courseId is plan.Course_Id
                    SelectedInd: [isSelected], // Mark as selected if it matches
                  })
                );
              }
            });
          }
        },
        (error) => {
          console.error('Error fetching course plans:', error);
        }
      );
  }

  checkDuplicateExamYear = (data: any[]) => {
    const examYearCount = new Map();
    const filtered = data.filter((e) => e.deleteInd === 'N');
    for (const item of filtered) {
      if (examYearCount.has(+item.examYear)) {
        console.log(`Duplicate found: Exam Year ${item.examYear}`);
        return true; // Found a duplicate
      }
      examYearCount.set(+item.examYear, 1);
    }

    console.log('No duplicates found in examYear.');
    return false;
  };
  isCoursePlanSelected(appExam: any, planCode: string): boolean {
    const selectedCoursePlans = appExam.get('selectedCoursePlans')?.value || [];
    return selectedCoursePlans.some(
      (plan: { CoursePlanTypeCode: string; SelectedInd: boolean }) =>
        plan.CoursePlanTypeCode === planCode && plan.SelectedInd
    );
  }

  // Handle course plan selection logic
  updateCoursePlanSelection(plan: IGetCodes, appExam: any, event: any) {
    const isChecked = event.target.checked;
    const selectedCoursePlanArray = appExam.get(
      'selectedCoursePlans'
    ) as FormArray;
    // Find the index of the course plan to update
    const planIndex = selectedCoursePlanArray.controls.findIndex(
      (control) => control.get('CoursePlanTypeCode')?.value === plan.Code
    );

    if (planIndex !== -1) {
      // Update the SelectedInd value if the plan already exists
      selectedCoursePlanArray.at(planIndex).patchValue({
        SelectedInd: isChecked,
      });
    } else {
      // Add a new plan if it doesn't exist in the array
      selectedCoursePlanArray.push(
        this.fb.group({
          CoursePlanTypeCode: [plan.Code],
          SelectedInd: [isChecked],
        })
      );
    }
  }

  //#region DeleteCourses
  deleteApplicablecourse(appExam: any) {
    const formGroup = appExam as FormGroup;
    const formGroupValue = appExam.value;
    const changedSelectedCoursePlans = formGroupValue.selectedCoursePlans.map(
      (e: any) => {
        return { ...e, SelectedInd: false };
      }
    );
    formGroup.get('deleteInd')?.setValue('Y');
    formGroup.get('selectedCoursePlans')?.setValue(changedSelectedCoursePlans);
    ['courseId', 'examAgency', 'examYear'].forEach((field) => {
      formGroup.get(field)?.removeValidators(Validators.required);
      formGroup.get(field)?.updateValueAndValidity();
    });
  }
  disableAllFields() {
    const studyMaterialsArray = this.getStudyMaterialsArray();
    studyMaterialsArray.controls.forEach((group) => {
      group.disable(); // Disable all form controls in the group
    });
  }

  checkIfEnabled(item: IGetCodes, appExam: any): boolean {
    // Ensure the appExam FormGroup and its coursePlan array are valid
    const coursePlan = appExam.get('coursePlan')?.value || [];
    // Check if the course plan contains an entry matching the provided item
    if (Array.isArray(coursePlan)) {
      return !coursePlan.some(
        (plan: any) => plan.Course_Plan_Type_Code === item.Code
      );
    }

    // If coursePlan is invalid or empty, return true (enabled by default)
    return true;
  }

  onCross() {
    this.activeModal.close(false);
  }
  // #region On Save
  onSave() {
    if (this.AddStudyMaterialform.valid) {
      const formData = new FormData();
      let stop = false;
      // LoggedInUser parameter
      formData.append('LoggedInUser', UserAuthDetails.getUserLoggedInId()); // Replace with the actual user ID

      // UDTStudyMaterialApplicableCourseCategory
      let categoryIndex = 0;
      this.AddStudyMaterialform.value.StudyMaterials.forEach(
        (studyMaterial: any) => {
          studyMaterial.Course_Category_Type.forEach((category: any) => {
            if (
              category.SelectedInd &&
              studyMaterial.Applicable_Exam_List.filter(
                (x: any) => x.type === category.CourseCategoryTypeCode
              ).every(
                (e: any) =>
                  e.selectedCoursePlans.length <= 0 ||
                  e.selectedCoursePlans.every((e: any) => !e.SelectedInd)
              )
            ) {
              this.toaster.error(
                `Please check any course plan type for Applicable course Type "${category.CourseCategoryTypeCode}" or uncheck it for Study Material (${studyMaterial?.StudyMaterialId})"`,
                'Error',
                { timeOut: ConstantVars.ToastErrorTimeout }
              );
              stop = true;
              return;
            }

            formData.append(
              `UDTStudyMaterialApplicableCourseCategory[${categoryIndex}][StudyMaterialID]`,
              studyMaterial.StudyMaterialId
            );
            formData.append(
              `UDTStudyMaterialApplicableCourseCategory[${categoryIndex}][CourseCategoryTypeCode]`,
              category.CourseCategoryTypeCode
            );
            formData.append(
              `UDTStudyMaterialApplicableCourseCategory[${categoryIndex}][SelectedInd]`,
              category.SelectedInd ? 'Y' : 'N'
            );
            categoryIndex++;
          });
        }
      );
      formData.append(
        'UDTStudyMaterialApplicableCourseCategoryLength',
        categoryIndex.toString()
      );
      if (stop) {
        return; // Prevents further execution
      }
      // UDTStudyMaterialApplicableCoursePlan
      const selectedCoursePlans: any[] = [];

      this.AddStudyMaterialform.value.StudyMaterials.forEach(
        (studyMaterial: any) => {
          studyMaterial.Applicable_Exam_List.forEach((exam: any) => {
            if (exam.selectedCoursePlans) {
              selectedCoursePlans.push(
                ...exam.selectedCoursePlans.map((plan: any) => ({
                  StudyMaterialID: studyMaterial.StudyMaterialId,
                  CourseID: exam.examYear,
                  CoursePlanTypeCode: plan.CoursePlanTypeCode,
                  SelectedInd: plan.SelectedInd ? 'Y' : 'N',
                }))
              );
            }
          });
        }
      );
      console.log(selectedCoursePlans);
      console.log(this.applicableCourses);
      this.applicableCourses.forEach((a1Item, index, self) => {
        const matchedA2 = selectedCoursePlans.find(
          (a2Item: any) => a2Item.StudyMaterialID === a1Item.Study_Material_Id
        );

        if (matchedA2) {
          // Ensure an exact match for StudyMaterialID & CourseID
          const exists = selectedCoursePlans.some(
            (a2Item) =>
              a2Item.StudyMaterialID === a1Item.Study_Material_Id &&
              +a2Item.CourseID === +a1Item.Course_ID
          );

          // Only add if an exact match is NOT found
          if (!exists) {
            self
              .filter((e) => e.Course_ID === a1Item.Course_ID)
              .forEach((e2) => {
                selectedCoursePlans.push({
                  StudyMaterialID: e2.Study_Material_Id,
                  CourseID: +e2.Course_ID,
                  CoursePlanTypeCode: e2.Course_Plan_Type_Code,
                  SelectedInd: 'N',
                });
              });
          }
        }
      });

      console.log(selectedCoursePlans);
      let planIndex = 0;

      selectedCoursePlans
        ?.filter((e) => e.CourseID)
        .forEach((plan: any) => {
          formData.append(
            `UDTStudyMaterialApplicableCoursePlan[${planIndex}][StudyMaterialID]`,
            plan.StudyMaterialID
          );
          formData.append(
            `UDTStudyMaterialApplicableCoursePlan[${planIndex}][CourseID]`,
            plan.CourseID
          );
          formData.append(
            `UDTStudyMaterialApplicableCoursePlan[${planIndex}][CoursePlanTypeCode]`,
            plan.CoursePlanTypeCode
          );
          formData.append(
            `UDTStudyMaterialApplicableCoursePlan[${planIndex}][SelectedInd]`,
            plan.SelectedInd
          );
          planIndex++;
        });

      formData.append(
        'UDTStudyMaterialApplicableCoursePlanLength',
        planIndex.toString()
      );

      this.service
        .InsertOrUpdateStudyMaterialApplicableCoursePlan$(formData)
        .subscribe(
          (res) => {
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
          },
          (error) => {
            console.log(error);
            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
    } else {
      this.AddStudyMaterialform.markAllAsTouched();
      this.toaster.error('Please fill all the higlighted fields', '', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
    }
    // Log FormData keys and values for verification
    // formData.forEach((value, key) => {
    //   console.log(key, value);
    // });
  }
}
